import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './ui/styles/index.css';
import { initAddinLanguage } from './i18n';
import { initializeTenantFirebase } from './config/firebase';
import { initRemoteDebugLog } from './utils/RemoteDebugLog';
import { installSearchBaselineProbe } from './features/hybridApply/searchBaselineProbe';
import { installMccAgentBridge } from './dev/mccAgentBridge';

// Touch this module to force a full taskpane reload when HMR cannot recover. (24)

/* global Office */

// Initialize the app
const initApp = async () => {
  initRemoteDebugLog();

  // Resolve the initial UI language (localStorage, else Hebrew default).
  // The user's saved server preference is applied after login.
  initAddinLanguage();

  try {
    await initializeTenantFirebase();
  } catch (error) {
    const container = document.getElementById('root');
    if (container) {
      container.innerHTML = '<div style="padding:16px;font-family:system-ui,sans-serif;color:#7f1d1d">Tenant authentication is not configured.</div>';
    }
    throw error;
  }

  // T-001 spike: expose window.__courtyardProbeSearchBaseline for the search-baseline capture.
  installSearchBaselineProbe();
  installMccAgentBridge();
  const container = document.getElementById('root');
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
};

// Check if Office.js is available
if (typeof Office !== 'undefined' && Office.onReady) {
  let initialized = false;
  const initOnce = () => {
    if (initialized) return;
    initialized = true;
    void initApp();
  };

  const officeFallbackTimer = window.setTimeout(() => {
    console.warn('Office.onReady did not resolve quickly - rendering diagnostic browser mode');
    initOnce();
  }, 3000);

  Office.onReady((info) => {
    window.clearTimeout(officeFallbackTimer);
    if (info.host === Office.HostType.Word) {
      initOnce();
    } else {
      console.warn('Add-in is not running in Word');
      initOnce(); // Still render for testing
    }
  });
} else {
  // Office.js not available (testing in browser)
  console.warn('Office.js not available - running in browser mode');
  void initApp();
}
